export const VehicleKey = {
  VEHICLE_TYPE: 'type',
  NO_UNITS: 'numberOfUnit',
  FUEL_USED: 'fuelUsed',
  IS_LEASED: 'isLeased',
  QUANTITY_TF: 'quantity',
  DRIVEN_TF: 'driven',
  FUEL_COST_TF: 'fuelcost',
  MAINTENANCE_COST_TF: 'maintenancecost',
  LESSOR_NAME: 'assetLessorName',
  MOBILE_NO: 'assetLessorMobile',
  RENTED_FROM: 'assetLessorRentedFrom',
  RENTED_TO: 'assetLessorRentedTo',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const VehicleLabel = {
  VEHICLE_TYPE: 'Vehicle Type',
  NO_UNITS: 'No. of Units',
  FUEL_USED: 'Fuel Used',
  IS_LEASED: 'Leased',
  QUANTITY_TF: 'Quantity',
  DRIVEN_TF: 'Driven',
  FUEL_COST_TF: 'Fuel Cost',
  MAINTENANCE_COST_TF: 'Maintenance Cost',
  LESSOR_NAME: 'Asset Lessor Name',
  MOBILE_NO: 'Asset Mobile Number',
  RENTED_FROM: 'Rented From',
  RENTED_TO: 'Rented To',
  STATUS: 'Status',
  COMMENT: 'Comment',
  STATUS_COMMENTS: 'Status & Comments'
};

export const VehicleTooltip = {
  FUEL_USED: 'Enter the total fuel used for all selected vehicles/units.',
  QUANTITY: 'Enter the total fuel quantity for all selected vehicles/units.',
  FUEL_COST: 'Enter the total fuel cost for all selected vehicles/units.',
  MAINTENANCE_COST:
    'Enter the total maintenance cost for all selected vehicles/units.',
  DRIVEN: 'Enter the total distance driven by all selected vehicles/units.'
};
